import { useContext, useEffect, useState } from 'react';

import { ControlsServiceContext } from '../../../automaticPanel/panelsService/ControlsServiceContext';
import { DefaultClient, GlobalDesignStyleGroup } from '../../types';
import { createDefaultClient } from '../../utils/createDefaultClient';

export function useControlService() {
  const { service } = useContext(ControlsServiceContext);
  return service;
}

export function useClient(group: GlobalDesignStyleGroup) {
  const [client, setClient] = useState<DefaultClient | null>(null);

  useEffect(() => {
    if (!client) {
      (async () => {
        const host = await group.createHost();

        setClient(createDefaultClient(host));
      })();
    }
  }, [group]);

  return client;
}
